import script from "./CModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CModal.vue?vue&type=script&setup=true&lang=ts"

import "./CModal.vue?vue&type=style&index=0&id=e07dfeca&scoped=true&lang=less"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e07dfeca"]])

export default __exports__